module.exports = __webpack_public_path__ + "1fe1c20d58cd62c47ee68c7fb5fa7c00.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-8.png
// module id = 1192
// module chunks = 0